import { FC } from "react";
import { useNavigate } from "react-router-dom";
import SimpleButton from "../../components/DesignSystem/Input/SimpleButton";

function NotFound() {
	const navigate = useNavigate();

	return (
		<div className="text-primary flex flex-col items-center justify-center sm:mt-8">
			{/* Content container */}
			<div className="h-full flex flex-col overflow-clip sm:rounded-3xl sm:border sm:border-primary-inactive sm:max-w-[402px] mb-4">
				<UxTitle />
				<UxMascot />
				<UxContent navigate={navigate} />
			</div>
		</div>
	);
}

const UxTitle: FC = () => {
	return (
		<div
			className="relative pt-8 pb-16 bg-cover bg-center"
			style={{ backgroundImage: "url(./headerContour.png)" }}
		>
			<h1 className="text-4xl font-bold text-primary ml-4 mb-2">404</h1>
		</div>
	);
};

const UxMascot: FC = () => {
	return (
		<div className="relative -mt-12 px-6">
			<div className="w-24 h-24 mx-auto">
				<img
					src="../mappy-icon-BW.png"
					alt="Mappy mascot"
					className="w-full object-cover"
				/>
			</div>
		</div>
	);
};

const UxContent: FC<{ navigate: (path: string) => void }> = ({ navigate }) => {
	return (
		<div className="mt-6 px-8 pb-6 space-y-4 text-primary">
			<h2 className="text-2xl font-semibold text-center">Page Not Found</h2>
			<p className="text-center text-error-inactive">
				Oops! The page you're looking for doesn't exist or has been moved.
			</p>
			<p className="text-center text-sm text-primary">
				Let's get you back on track.
			</p>
			<div className="flex flex-col gap-3 pt-4">
				<SimpleButton
					onClick={() => navigate("/dashboard")}
					className="h-10 border-primary-accent hover:border-primary-active active:border-primary-active border text-primary rounded-full"
				>
					<p>Go to Dashboard</p>
				</SimpleButton>
				<SimpleButton
					onClick={() => navigate("/landing")}
					className="h-10 border-primary-accent hover:border-primary-active active:border-primary-active border text-primary rounded-full"
				>
					<p>Sign up</p>
				</SimpleButton>
			</div>
		</div>
	);
};

export default NotFound;
